import { inject, Injectable } from '@angular/core';
import { fromEvent, map, startWith } from 'rxjs';
import { DEVICE_SIZE, mediaConfig } from '@core/models/deviceSize.model';
import { WindowRef } from '@shared/tools/window';

@Injectable({ providedIn: 'root' })
export class DeviceService {
  private winRef = inject(WindowRef);

  onResize$ = fromEvent(this.winRef.nativeWindow!, 'resize').pipe(
    startWith(null),
    map(() => this.getSizeScreen()),
  );

  getCurrentSize(): DEVICE_SIZE {
    const screenSize = this.getSizeScreen();

    const deviceSize = Object.entries(mediaConfig.mediaFormats)
      .map(([size, config]) => ({ size: size as DEVICE_SIZE, width: config.width }))
      .sort((a, b) => b.width - a.width)
      .find(entry => screenSize.width >= entry.width)?.size;

    return deviceSize ?? DEVICE_SIZE.MOBILE;
  }

  getSizeScreen() {
    return {
      width: this.winRef.nativeWindow?.innerWidth || 1920,
      height: this.winRef.nativeWindow?.innerHeight || 1080,
    };
  }

  isScreenSizeAtLeast(size: DEVICE_SIZE): boolean {
    const screenWidth = this.getSizeScreen().width;
    const limitWidth = mediaConfig!.mediaFormats![size]!.width!;
    return screenWidth >= limitWidth;
  }
}
